import {
    CommonRoutes,
    FilterType,
} from 'app/enums/common.enums'
import {
    ActivityRecordType,
} from 'app/enums/label.enums'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    RequestConfig,
} from 'app/types/request.types'
import {
    SkyNetTableField,
} from 'app/shared-components/SkyNetTable'
import {
    ActivityRecordTable,
} from 'app/Apps/RelationshipsManagement/ActivityRecords/activityRecords.types'
import ActivityRecordDemoOverview from 'app/PoC/DataGridDemoPages/ActivityRecordsDemo/ActivityRecordDemoOverview'
import ActivityRecordsRequests from 'app/requests/ActivityRecords.requests'
import {
    SkyNetObjectConfigParams,
} from 'app/PoC/DataGridDemoPages/SkyNetObjectRoutes/SkyNetObjectRoutes.types'
import ActivityRecordCreate from 'app/Apps/RelationshipsManagement/ActivityRecords/ActivityRecordCreate'

import ActivityRecordDemoEditForm from './ActivityRecordDemoEditForm'

const columns: SkyNetTableField<keyof ActivityRecordTable>[] = [
    {
        name: 'companiesCompanyName',
        componentName: 'List',
        filterField: 'companiesCompanyName',
        filterType: FilterType.Array,
        reduced: true,
        labelKey: 'ActivityRecords.companyName',
    },
    {
        name: 'participants',
        componentName: 'List',
        reduced: true,
        labelKey: 'ActivityRecords.participants',
    },
    {
        name: 'subject',
        reduced: true,
        labelKey: 'ActivityRecords.subject',
    },
    {
        name: 'type',
        componentName: 'EnumValue',
        allowedValuesEnum: ActivityRecordType,
        labelKey: 'ActivityRecords.type',
    },
    {
        name: 'organizer',
        filterField: 'organizer',
        reduced: true,
        filterType: FilterType.Array,
        labelKey: 'ActivityRecords.organizer',
    },
    {
        name: 'isFollowUpNeeded',
        filterField: 'isFollowUpNeeded',
        filterType: FilterType.Array,
        componentName: 'ChipCheckMark',
        labelKey: 'ActivityRecord.followUpNeeded',
    },
    {
        name: 'happenedOn',
        labelKey: 'ActivityRecords.happenedOn',
        componentName: 'DateTimeCell',
    },
    {
        name: 'durationInMinutes',
        componentName: 'AmountOfTime',
        labelKey: 'ActivityRecords.duration',
    },
    {
        name: 'changedOn',
        labelKey: 'ActivityRecords.changedOn',
        componentName: 'DateTimeCell',
    },
]

const request: RequestConfig = {
    url: 'activityrecord/filter-request/all',
    method: 'POST',
} // TODO-DK: for test purposes only, remove it afterwards, take from requests.ts

export const formViews = [
    {
        label: 'Overview',
        url: CommonRoutes.Overview,
        Component: ActivityRecordDemoOverview,
        skyNetQueryLoaderConfig: {
            requestConfigFunction: ActivityRecordsRequests.get,
            requestKey: RequestKeys.getActivityRecord,
        },
    },
    {
        label: 'Data Update',
        url: CommonRoutes.Update,
        Component: ActivityRecordDemoEditForm,
        skyNetQueryLoaderConfig: {
            requestConfigFunction: ActivityRecordsRequests.get,
            requestKey: RequestKeys.getActivityRecord,
        },
    },
]

const activityRecordDomainConfig: SkyNetObjectConfigParams<keyof ActivityRecordTable> = {
    persistentKey: 'demo-activityRecords-table',
    formViews,
    columns,
    uniqField: 'id',
    config: [{
        url: CommonRoutes.All,
        name: 'All',
        requestKey: RequestKeys.getActivityRecords,
        request,
    }],
    actionComponents: {
        Create: {
            component: ActivityRecordCreate,
            accessOnly: [
                'relationships_ops',
                'relationships_sales',
            ],
        },
    },
}

export default activityRecordDomainConfig
